import { useContext } from 'react';
import { ContentContext } from '../../contexts/ContentContext';
import useContent from '../../hooks/useContent';
import useUnsavedChanges from '../../hooks/useUnsavedChanges';
import AdminTopbar from '../AdminTopbar';
import SaveBar from '../components/SaveBar';

export default function NavEditor() {
  const { content, updateSection } = useContext(ContentContext);
  const { draft, isDirty, saving, lastSaved, update, save, discard } =
    useContent(content.navigation);
  useUnsavedChanges(isDirty);

  const handleSave    = () => save(patch => updateSection('navigation', patch));
  const handleDiscard = () => discard(content.navigation);

  const links = draft.links || [];

  const updateLink = (i, patch) => {
    const next = links.map((l, idx) => idx === i ? { ...l, ...patch } : l);
    update({ links: next });
  };

  const addLink = () => update({ links: [...links, { label: 'New Link', href: '/' }] });

  const removeLink = (i) => update({ links: links.filter((_, idx) => idx !== i) });

  const moveLink = (from, to) => {
    const next = [...links];
    const [item] = next.splice(from, 1);
    next.splice(to, 0, item);
    update({ links: next });
  };

  return (
    <div className="adm-page">
      <AdminTopbar title="Navigation" />
      <SaveBar isDirty={isDirty} saving={saving} lastSaved={lastSaved}
               onSave={handleSave} onDiscard={handleDiscard} />

      <div className="adm-editor">
        <section className="adm-section">
          <h3 className="adm-section__title">Nav Links</h3>

          <div className="adm-list">
            {links.map((link, i) => (
              <div key={i} className="adm-list__row" draggable
                onDragStart={e => e.dataTransfer.setData('text/plain', i)}
                onDragOver={e => e.preventDefault()}
                onDrop={e => { e.preventDefault(); moveLink(+e.dataTransfer.getData('text/plain'), i); }}>
                <span className="adm-list__drag">⠿</span>
                <input className="adm-input adm-input--sm" placeholder="Label"
                  value={link.label} onChange={e => updateLink(i, { label: e.target.value })} />
                <input className="adm-input adm-input--sm" placeholder="/path"
                  value={link.url || link.href || ''} onChange={e => updateLink(i, { url: e.target.value })} />
                <button className="adm-btn adm-btn--danger adm-btn--sm"
                  onClick={() => removeLink(i)}>✕</button>
              </div>
            ))}
          </div>

          <button className="adm-btn adm-btn--ghost" onClick={addLink}>+ Add Link</button>
        </section>

        <section className="adm-section">
          <h3 className="adm-section__title">CTA Button</h3>

          <div className="adm-field">
            <label className="adm-label">Button Label</label>
            <input className="adm-input" value={draft.ctaLabel || ''}
              onChange={e => update({ ctaLabel: e.target.value })} />
          </div>

          <div className="adm-field">
            <label className="adm-label">Button URL</label>
            <input className="adm-input" value={draft.ctaUrl || ''}
              onChange={e => update({ ctaUrl: e.target.value })} />
          </div>
        </section>
      </div>
    </div>
  );
}
